<template>
  <div class="coverband">
    <VideoBanner :v-if='$route.name === "Coverband"' posterSrc='band.jpg' mp4Src='band.mp4' webmSrc='band.webm' :overlayTitle='$COMPANY.NAME' :overlayDescription='$COMPANY.DESCRIPTION' />
    <div class="main-content small-content">
      <b-container>
        <h2>Cover/Tribute &amp; Partyband</h2>
        <div class="coverband-content page-content">
          <b-row>
            <b-col>
              <h3>Musik som känns - från första låt till sista refräng</h3>
              <p>Letar du efter ett band som verkligen höjer nivån på ditt event? Vi erbjuder allt från ösiga partyband och breda coverband till specialiserade temaband och hyllade tributeband anpassade för just din kväll.</p>
              <h3>Coverband & Partyband som får igång festen</h3>
              <p>Oavsett om ni är ute efter moderna hits, klassiker eller en blandning, levererar våra band med energi, erfarenhet och känsla. Perfekt för bröllop, företagsfester, jubileum eller andra tillfällen där dansgolvet ska leva.</p>
              <h3>Tributeband med kärlek till originalen</h3>
              <p>För dig som vill ha en helkväll med musik från ett visst band eller artist så kan du vara trygg i att våra tributeband går all in. Ljud, look och känsla återskapas med passion och professionalism.</p>
              <h3>Temaband & flexibla lösningar</h3>
              <p>Från 60-tal till disco, soul, rock eller afterski, vi har temabanden som matchar stilen du är ute efter. Behöver du ett band till mingel, middagsunderhållning eller för att kompa gästartister? Vi fixar det också.</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import VideoBanner from './VideoBanner'

export default {
  components: {
    VideoBanner
  }
}
</script>

<style>

</style>
